<template>
  <div>
    <div class="head">
      <el-breadcrumb style="margin-left:20px" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: 'twoOrderNew', query: { status: 'second' }}">两单管理</el-breadcrumb-item>
        <el-breadcrumb-item>管控详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <div style="width: 80%;margin: auto;padding-bottom:10px">
        <div style="margin: 50px 0">
          <el-divider content-position="left">
            <span style="color: 666666; font-size: 16px">基础信息</span>
          </el-divider>
        </div>
        <div class="detailBox">
          <div>
            风险点：
            <span>{{ obj.riskName }}</span>
          </div>
          <div>
            所属部门：
            <span>{{ obj.depName }}</span>
          </div>
          <div>
            责任人：
            <span>{{ obj.responsibleEmpName }}</span>
          </div>
          <div>
            管控人：
            <span>{{ obj.controlEmpName }}</span>
          </div>
          <div>
            管控层级：
            <span>{{ controlHierarchyList[obj.controlHierarchy] }}</span>
          </div>
          <div>
            审核人：
            <span>{{ obj.auditEmpName }}</span>
          </div>
          <div>
            审核状态：
            <span v-if="obj.status === 0" style="color: #F56C6C">未审核</span>
            <span v-else style="color: #67C23A">审核完成</span>
          </div>
          <div>
            审核时间：
            <span>{{ obj.auditTime }}</span>
          </div>
          <div>
            审核内容：
            <pre>{{ obj.auditOpinion }}</pre>
          </div>
        </div>
        <div style="margin: 50px 0">
          <el-divider content-position="left">
            <span style="color: 666666; font-size: 16px">管控内容</span>
          </el-divider>
        </div>
        <el-table :data="tableData" border max-height="600" style="width: 100%"
          :header-cell-style="{ background: 'white', fontWeight: 600, textAlign: 'center', padding: '8px 0' }"
          :cell-style="{ textAlign: 'center' }">
          <el-table-column label="管控内容">
            <el-table-column prop="project" label="检查项目/作业步骤"></el-table-column>
            <el-table-column prop="name" label="检查标准/风险源或潜在事件"></el-table-column>
            <el-table-column prop="riskFactor" label="风险因素"></el-table-column>
            <el-table-column prop="riskDescription" label="不符合标准状况/可能发生事故描述"></el-table-column>
            <el-table-column prop="type" label="易发事故类型"></el-table-column>
            <el-table-column prop="consequence" label="危害/后果"></el-table-column>
          </el-table-column>
        </el-table>
        <el-table :data="tableData" border max-height="600" style="width: 100%;margin-top: 30px"
          :header-cell-style="{ background: 'white', fontWeight: 600, textAlign: 'center', padding: '8px 0' }"
          :cell-style="{ textAlign: 'center' }">
          <el-table-column label="措施">
            <el-table-column prop="technicalMeasure" label="工程技术措施" />
            <el-table-column prop="managementMeasure" label="管理措施" />
            <el-table-column prop="trainingMeasure" label="培训教育措施" />
            <el-table-column prop="personalFenceMeasure" label="个体防护措施" />
            <el-table-column prop="emergencyMeasure" label="应急处置措施" />
          </el-table-column>
        </el-table>
        <div style="margin: 50px 0">
          <el-divider content-position="left">
            <span style="color: 666666; font-size: 16px">管控跟踪列表</span>
          </el-divider>
        </div>
        <el-table :data="reviewData" border max-height="600" style="width: 100%;margin-top: 30px"
          :header-cell-style="{ background: 'white', fontWeight: 600, textAlign: 'center', padding: '8px 0' }"
          :cell-style="{ textAlign: 'center' }">
          <el-table-column label="管控跟踪详情">
            <el-table-column prop="implementation" label="落实状况" />
            <el-table-column prop="managementMeasure" label="补充管控措施" />
            <el-table-column prop="gmtCreateTime" label="评价时间">
              <template slot-scope="{ row }">
                {{ row.gmtCreate | filterTime }}
              </template>
            </el-table-column>
            <el-table-column prop="nextEvaluateTime" label="复评时间">
              <template slot-scope="{ row }">
                {{ row.nextEvaluateTime | filterTime }}
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="{ row }">
                <el-button type="text" @click="deleteReview(row.id)" style="color: red">删除</el-button>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { riskControlReviewList, riskControlReviewDelete } from "@/api/processManager";
export default {
  name: 'riskControlDetail',
  data() {
    return {
      obj: {},
      tableData: [],
      reviewData: [],
      // 管控层级的数组
      controlHierarchyList: ['公司级', '车间级', '班组级', '岗位级']
    }
  },
  created() {
    this.obj = this.$route.params.data;
    this.tableData = [];
    this.tableData.push(this.$route.params.data.measure)
    this.getReviewData()
  },
  filters: {
    filterTime(time) {
      return time.split(' ')[0]
    },
  },
  methods: {
    // 获取复评详情
    getReviewData() {
      riskControlReviewList({ riskControlId: this.$route.params.data.id }).then(res => {
        this.reviewData = res.body.data
      })
    },
    // 复评记录删除
    deleteReview(id) {
      riskControlReviewDelete(id).then(res => {
        this.$message.success('删除成功');
        this.getReviewData()
      })
    }
  }
}
</script>

<style scoped>
.detailBox div {
  width: 50%;
  font-size: 16px;
  line-height: 40px;
  font-weight: 500;
  color: #555555;
}
.tableBox {
  margin-top: 15px;
}
.tableBox .tableBoxTitle {
  font-size: 16px;
  font-weight: 600;
  color: #666666;
}
.a {
  font-size: 16px;
  line-height: 40px;
  font-weight: 500;
  color: #555555;
}
.detailBox > div > span {
  color: #888888;
}
.a > span {
  color: #888888;
}
pre {
  line-height: 20px;
  font-size: 16px;
  display: inline-block;
  vertical-align: top;
  margin-top: 10px;
}
</style>